const role = {
    ADMIN:"ADMIN",
    GENERAL:"GENERAL"
}

export default role